import React, { useState, useRef, useEffect } from 'react';
import Icon from '../Icon';

export interface DropdownItem {
  value: string;
  label: string;
}

const CustomDropdown = ({ className, dropdownItems, handleItemSelection }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const items: DropdownItem[] = dropdownItems;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) &&
        buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleItemClick = (value: string) => {
    setIsOpen(false);
    handleItemSelection(value);
    // HANDLEcLICK
  };

  // const handleItemSelection = (value: string) => {
  //   console.log('Selected option:', value);
  //   // Add your custom logic here
  //   alert(`You selected: ${value}`);
  // };

  return (
    <div className={"relative inline-block " + className} ref={dropdownRef}>
      <button
        ref={buttonRef}
        className="flex items-center justify-center w-8 h-8 p-2 bg-grey-300 rounded-md cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        {/* <div className={`w-0 h-0 border-l-[5px] border-r-[5px] border-b-0 border-t-[5px] border-l-transparent border-r-transparent border-t-gray-700 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`} /> */}
        <div className={isOpen && 'transform rotate-180'}>

          <Icon name="arrow-down2" />
          {/* <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg"><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg> */}

        </div>
        {/* <div className={`hidden w-0 h-0 border-l-[5px] border-r-[5px] border-b-0 border-t-[5px] border-l-transparent border-r-transparent border-t-gray-700 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`} >
        </div> */}
      </button>

      {isOpen && (
        <div className="absolute left-0 z-10 w-40 mt-1 bg-black border border-gray-200 rounded-md shadow-lg transition-opacity duration-200">
          {items.map((item) => (
            <div
              key={item.value}
              className="px-4 py-2 text-sm text-white-700 cursor-pointer hover:bg-gray-100 hover:text-black active:bg-gray-200 transition-colors duration-150"
              onClick={() => handleItemClick(item.value)}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
